import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { GetDataModulesHomeReducer } from "../../Redux/Actions/Home/Home";
import { HashLink as RouterHashLink } from "react-router-hash-link";
import { RegisterUsersConnectedHomeModulesReducer, SelectModuleActiveClickHomeModulesReducer, SelectModuleActiveHoverHomeModulesReducer, SelectModuleSelectedHomeModulesReducer } from "../../Redux/Actions/HomeModules/HomeModules";
import { Row, Col, Tabs } from "antd";
import socket from "../../App/socket";
import SoundOption from "../../Assets/Audio/sonidoOptionNew.mp3";
import CardSubmodule1 from "../../Components/CardHomeModule/CardSubmodule1/CardSubmodule1";
import CardSubModule2 from "../../Components/CardHomeModule/CardSubmodule2/CardSubModule2";
import CardSubModule3 from "../../Components/CardHomeModule/CardSubmodule3/CardSubModule3";
import CardSubModule4 from "../../Components/CardHomeModule/CardSubmodule4/CardSubModule4";
import CardSubModule5 from "../../Components/CardHomeModule/CardSubmodule5/CardSubModule5";
import CardSubModule6 from "../../Components/CardHomeModule/CardSubmodule6/CardSubModule6";
import CardSubModule7 from "../../Components/CardHomeModule/CardSubmodule7/CardSubModule7";
import CardSubmodule8 from "../../Components/CardHomeModule/CardSubmodule8/CardSubModule8";
import SideMenu from "../../Components/Global/SideMenu";

const HomeModules = () => {
  const dispatch = useDispatch();
  const audio = new Audio(SoundOption);

  // Redux selectors
  const { rex_data_modulos_dashboards_total } = useSelector(({ dashboards }) => dashboards);
  const { rex_data_users_online } = useSelector(({ users }) => users);
  const { rex_data_user_logingrow } = useSelector(({ loginGrow }) => loginGrow);
  const { rex_users_home_modules_connected, rex_module_selected_home_modules, rex_module_active_click_home_modules, rex_module_active_hover_home_modules } = useSelector(({ homeModules }) => homeModules);

  const reproduceSound = () => {
    audio.play();
  };

  // Initial data fetch
  useEffect(() => {
    dispatch(GetDataModulesHomeReducer());
  }, [dispatch]);

  // Socket for category updates
  useEffect(() => {
    socket.on("update-category", () => {
      dispatch(GetDataModulesHomeReducer());
    });

    return () => {
      socket.off("update-category");
    };
  }, [dispatch]);

  // Socket for user module connections
  useEffect(() => {
    socket.on("get-users-modules", (data_users) => {
      dispatch(RegisterUsersConnectedHomeModulesReducer(data_users));
    });

    // Register user when component mounts
    if (rex_data_user_logingrow?.usuusuario) {
      socket.emit("reg-modules", { module: "status" }, { usuusuario: rex_data_user_logingrow.usuusuario });
    }

    return () => {
      if (rex_data_user_logingrow?.usuusuario) {
        socket.emit("unreg-modules", { module: "status" }, { usuusuario: rex_data_user_logingrow.usuusuario });
      }
      socket.off("get-users-modules");
    };
  }, [dispatch, rex_data_user_logingrow]);

  // Helper function to render the appropriate card based on number of children
  const renderModuleCard = (mod, children) => {
    const props = {
      module: mod,
      submodule: children,
      titlemodule: mod.modnombre,
      activeModule: rex_module_selected_home_modules,
      modid: mod.modid,
    };

    switch (children.length) {
      case 1:
        return <CardSubmodule1 {...props} />;
      case 2:
        return <CardSubModule2 {...props} />;
      case 3:
        return <CardSubModule3 {...props} />;
      case 4:
        return <CardSubModule4 {...props} />;
      case 5:
        return <CardSubModule5 {...props} />;
      case 6:
        return <CardSubModule6 {...props} />;
      case 7:
        return <CardSubModule7 {...props} />;
      case 8:
        return <CardSubmodule8 {...props} />;
      default:
        return null;
    }
  };

  const handleModuleChange = (moduleId) => {
    dispatch(SelectModuleSelectedHomeModulesReducer(moduleId));
    dispatch(SelectModuleActiveClickHomeModulesReducer(moduleId));
  };

  const tabItems = rex_data_modulos_dashboards_total.map((mod) => {
    const isActive = rex_module_active_click_home_modules === mod.modid;
    const isHovered = rex_module_active_hover_home_modules === mod.modid;

    const isArriendos = mod.modruta.includes("arriendos");

    return {
      key: mod.modid,
      label: (
        <div className="Title-Module-Tabs" onMouseEnter={reproduceSound} onMouseOver={() => dispatch(SelectModuleActiveHoverHomeModulesReducer(mod.modid))} onMouseLeave={() => dispatch(SelectModuleActiveHoverHomeModulesReducer(null))}>
          <Link to={isArriendos ? "/status" : "/home-modules"} state={mod.modid}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                className="Icon-Title-Module-Tabs"
                style={{
                  position: "absolute",
                  width: isActive || isHovered ? "23px" : "0",
                  transition: isActive || isHovered ? "width .3s .6s" : "width .3s",
                  zIndex: 2,
                }}
              />
              <span
                className="Icon-Title-Module-Tabs"
                style={{
                  position: "absolute",
                  width: isActive || isHovered ? "6px" : "0",
                  backgroundColor: "#2AD295",
                  transition: "width .5s",
                  zIndex: 1,
                }}
              />
              <span
                style={{
                  marginLeft: isActive || isHovered ? "17px" : "0",
                  paddingLeft: isActive || isHovered ? "11px" : "0",
                  transition: isActive ? "margin-left .3s .6s, padding-left .5s" : isHovered ? "margin-left .3s .6s, padding-left .5s" : "margin-left .5s, padding-left .5s .2s",
                }}
              >
                {mod.modnombre}
              </span>
            </div>
          </Link>
        </div>
      ),
      children: renderModuleCard(mod, mod.children),
    };
  });

  return (
    <div className="Container-Main" style={{ paddingBottom: "5px", paddingTop: "52px" }}>
      <Row style={{ marginBottom: "15px" }}>
        <Col span={24}>
          <Tabs
            className="Module-Tabs"
            activeKey={rex_module_selected_home_modules}
            tabPosition="left"
            onChange={handleModuleChange}
            tabBarExtraContent={{
              left: (
                <RouterHashLink to="/home#Category" style={{ position: "relative", zIndex: 1 }}>
                  <div className="Title-Module">Categorías</div>
                </RouterHashLink>
              ),
            }}
            items={tabItems}
          />
        </Col>
      </Row>
      {rex_users_home_modules_connected && <SideMenu usersCurrentView={rex_users_home_modules_connected} usersAllConnected={rex_data_users_online} />}
    </div>
  );
};

export default HomeModules;
